<div class="client-page-content">
  <div class="content-header" *ngIf="!payOnlyPage">
    <h2>{{ 'CLIENT.clientSuccess.title' | translate }}</h2>
  </div>

  <div class="row justify-content-center">
    <div class="col-md-10 col-sm-10 col-10">

      <div class="success" *ngIf="booking?.paymentMethod !== 'mbway' && booking?.paymentMethod !== 'mbref'">
        <div class="ico" data-nosnippet>
          <i class="material-icons icon">check</i>
        </div>
        <h3>
          {{ 'CLIENT.clientSuccess.thankYou' | translate }}
        </h3>
        <!-- <p class="edit-msg">Pode alterar ou cancelar a sua marcação a qualquer momento através do link no seu e-mail.</p> -->
      </div>

      <div class="resume text-center" *ngIf="booking?.paymentMethod === 'mbway'">
        <img class="mb-3" src="assets/ico-mbway.png" style="width: auto; height: 48px;">
        <p class="mb-2"><strong>{{'CLIENT.clientSuccess.mbwayTitle' | translate}}</strong></p>
        <p>{{ (payOnlyPage ? 'CLIENT.clientSuccess.mbwaySuccessPayOnly' : 'CLIENT.clientSuccess.mbwaySuccess') | translate }} <ng-container *ngIf="!payOnlyPage">{{ 'CLIENT.clientSuccess.mbwaySuccessAlert' | translate }}</ng-container>
        </p>
      </div>

      <div class="resume text-center" *ngIf="booking?.paymentMethod === 'mbref'">

        <img class="mb-3" src="assets/ico-mb.png" style="width: auto; height: 48px;">
        <p class="mbway-info text-bold">{{ (payOnlyPage ? 'CLIENT.clientSuccess.mbwaySuccessPayOnly' : 'CLIENT.clientSuccess.mbwaySuccess') | translate }}</p>
        <div class="bg-gray p-3 rd-3">

          <div class="d-flex mb-1">
            <div class="item w-50 text-right">
              <p class="color-gray mb-0">{{ 'SHARED.paymentModal.mbrefEntity' | translate }}</p>
            </div>
            <div class="item w-50 text-left">
              <p class="ml-2 mb-0 text-bold">{{booking.paymentData.entidade}}</p>
            </div>
          </div>
          <div class="d-flex mb-1">
            <div class="item w-50 text-right">
              <p class="color-gray mb-0">{{ 'SHARED.paymentModal.mbrefReference' | translate }}</p>
            </div>
            <div class="item w-50 text-left">
              <p class="ml-2 mb-0 text-bold">{{convertMBref(booking.paymentData.referencia)}}</p>
            </div>
          </div>
          <div class="d-flex mb-1">
            <div class="item w-50 text-right">
              <p class="color-gray mb-0">{{ 'SHARED.paymentModal.mbrefAmount' | translate }}</p>
            </div>
            <div class="item w-50 text-left">
              <p class="ml-2 mb-0 text-bold">{{booking.paymentData.valor | currency:'EUR':'symbol-narrow':'1.0-2'}}</p>
            </div>
          </div>

          <p class="text-small text-danger mb-0" *ngIf="!payOnlyPage">{{ 'CLIENT.clientSuccess.mbSuccessAlert' | translate:{time: mbrefTime} }} ({{mbrefTimeLimit | date: formatTime}}) {{ 'CLIENT.clientSuccess.mbSuccessAlert2' | translate }}</p>

        </div>

      </div>

      <div class="resume text-center">

        <p *ngIf="booking?.multipleBookings?.length">
          <ng-container *ngFor="let service of booking?.multipleBookings; let i = index">
            <strong>{{ service?.service?.name }}</strong> <span *ngIf="store?.showProviderInfoOnNotifications">({{ service.provider.name }})</span><span *ngIf="i < booking.multipleBookings.length - 1">, </span>
          </ng-container>
          <br />{{booking?.dateInit | dateFix | date:'longDate'}}, {{booking?.dateInit | dateFix | date : formatTime}}

        </p>

        <p class="mb-4" *ngIf="!booking?.multipleBookings?.length">
          <strong>{{ booking?.service?.name }}</strong>
          <br/>{{booking?.dateInit | dateFix | date:'longDate'}}, {{booking?.dateInit | dateFix | date : formatTime}}
          <br/><span *ngIf="store?.showProviderInfoOnNotifications && booking?.provider?.name">{{ booking?.provider?.name }} - </span>{{ store?.name }}
        </p>

        <!-- <p>
          {{day.day | dateFix | date:'longDate'}} - {{time?.start}}<br />
        </p> -->

        <div class="d-flex flex-column">
          <a class="btn btn-md btn-gray btn-flex mb-2" target="_blank" href="{{booking?.googleCalendarUrl}}">{{ 'CLIENT.clientSuccess.addToGoogleCalendar' | translate }}</a>
          <a class="btn btn-md btn-gray btn-flex" target="_blank" href="{{booking?.icalCalendarUrl}}">{{ 'CLIENT.clientSuccess.addToCalendar' | translate }}</a>
        </div>

      </div>


    </div>
  </div>

</div>
